import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-switchå¼å³éæ©å¨
 * 
 * å¼å³éæ©å¨ã
 * 
 * éè¦è¡¨ç¤ºå¼å³ç¶æ/ä¸¤ç§ç¶æä¹é´çåæ¢æ¶ã
 * 
 * åÂ checkboxçåºå«æ¯ï¼åæ¢Â switchÂ ä¼ç´æ¥è§¦åç¶ææ¹åã
 * 
 * èÂ checkboxÂ ä¸è¬ç¨äºç¶ææ è®°ï¼éè¦åæäº¤æä½éåã
 * 
 */
@Component({
    selector: 'fc-switch',
    template: `
<nz-switch *ngIf="fcShowLabel==='N'" [ngClass]="{'fc-readonly':_readonly===true}" [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" 
    [nzDisabled]="_disabled" [nzSize]="fcSize"
    [nzCheckedChildren]="fcCheckedChildren" 
    [nzUnCheckedChildren]="fcUnCheckedChildren">
    <ng-container *ngFor="let option of _options">
        <span *ngIf="fcCheckValue===option.value" checked>{{option.label}}</span>
        <span *ngIf="fcCheckValue!==option.value" unchecked>{{option.label}}</span>
    </ng-container>
</nz-switch>
<nz-switch *ngIf="fcShowText!==undefined&&fcShowLabel==='N'" [ngClass]="{'fc-readonly':_readonly===true}" [(ngModel)]="innerValue" 
    (ngModelChange)="checkValidator($event)" [nzDisabled]="_disabled" [nzSize]="fcSize"
    [nzCheckedChildren]="fcCheckedChildren" 
    [nzUnCheckedChildren]="fcUnCheckedChildren">
</nz-switch>
<nz-switch *ngIf="fcShowIcon!==undefined&&fcShowLabel==='N'" [ngClass]="{'fc-readonly':_readonly===true}" 
    [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzDisabled]="_disabled" [nzSize]="fcSize"
    [nzCheckedChildren]="checkedTemplate" 
    [nzUnCheckedChildren]="unCheckedTemplate">
</nz-switch>
<ng-template #checkedTemplate><i class="icon iconfont {{fcCheckedChildren}}"></i></ng-template>
<ng-template #unCheckedTemplate><i class="icon iconfont {{fcUnCheckedChildren}}"></i></ng-template>
<div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
    <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
    <div nz-col [nzSpan]="valueSpan">
        <nz-switch *ngIf="!fcShowText&&!fcShowIcon&&fcShowText===undefined&&fcShowIcon===undefined"  [ngClass]="{'fc-readonly':_readonly===true}"
            [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" 
            [nzDisabled]="_disabled" [nzSize]="fcSize"
            [nzCheckedChildren]="fcCheckedChildren" 
            [nzUnCheckedChildren]="fcUnCheckedChildren">
            <ng-container *ngFor="let option of _options">
                <span *ngIf="fcCheckValue===option.value" checked>{{option.label}}</span>1
                <span *ngIf="fcCheckValue!==option.value" unchecked>{{option.label}}</span>
            </ng-container>
        </nz-switch>
        <nz-switch *ngIf="fcShowText!==undefined" [ngClass]="{'fc-readonly':_readonly===true}" [(ngModel)]="innerValue" 
            (ngModelChange)="checkValidator($event)" [nzDisabled]="_disabled" [nzSize]="fcSize"
            [nzCheckedChildren]="fcCheckedChildren" 
            [nzUnCheckedChildren]="fcUnCheckedChildren">
        </nz-switch>
        <nz-switch *ngIf="fcShowIcon!==undefined" [ngClass]="{'fc-readonly':_readonly===true}" 
            [(ngModel)]="innerValue" (ngModelChange)="checkValidator($event)" [nzDisabled]="_disabled" [nzSize]="fcSize"
            [nzCheckedChildren]="checkedTemplate" 
            [nzUnCheckedChildren]="unCheckedTemplate">
        </nz-switch>
        <ng-template #checkedTemplate><i class="icon iconfont {{fcCheckedChildren}}"></i></ng-template>
        <ng-template #unCheckedTemplate><i class="icon iconfont {{fcUnCheckedChildren}}"></i></ng-template>
        <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
            {{fcHelp}}
        </div>
        <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
            <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.required}}</div>
            </div>
            <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
            </div>
            <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
            </div>
        </div>
        </div>
    </div>
    `,
    styles: [
        `
        .fc-readonly {
            pointer-events: none;
        }
        :host ::ng-deep .fc-readonly .ant-input-number-input-wrap{
            background-color: #ccc;
        }
        .form-explain {
            position:relative;
        }
        .explain{
            white-space: nowrap;
            position:absolute;
            right: -1px;
            bottom: 24px;
            z-index:10;
        }
        .explain-inner {
            position:relative;
            color:red;
        }
        .explain-inner:after{
            content: '';
            width: 10px;
            height: 12px;
            display: block;
            background-color: #ffffff;
            border-right: 1px solid #e9e9e9;
            border-bottom: 1px solid #e9e9e9;
            position: absolute;
            bottom: -6px;
            right: 12px;
            transform: rotate(45deg);
            z-index: 0;
        }
        .explain-tips{
            padding: 0px 10px;
            background-color: #ffffff;
            border: 1px solid #e9e9e9;
            border-radius: 4px;
            font-size: 12px;
            height: 30px;
            line-height: 28px;
        }
        `
    ],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FcswitchComponent),
        multi: true
    }]
})
export class FcswitchComponent extends FcinputComponent {
     /**åºåå¼ï¼*/
    @Input()
    fcCheckValue: any;
     /**æ¾ç¤ºæå­*/
    @Input()
    fcShowText: string;
    _showText: boolean;
     /**æ¾ç¤ºå¾æ */
    @Input()
    fcShowIcon: string;
    _showIcon: boolean;
     /**éä¸­æ¶çåå®¹*/
    @Input()
    fcCheckedChildren: string;
     /**ééä¸­æ¶çåå®¹*/
    @Input()
    fcUnCheckedChildren: string;
    _options: any[] = [];
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-switch');
        if (this.fcCheckValue === undefined) {
            this.fcCheckValue = true;
        }
        if (this.fcOption === undefined) {
            if (this.fcCheckValue instanceof Boolean) {
                this.fcOption = "[{'label':true,'value':true},{'label':false,'value':false}]";
            } else {
                this.fcOption = "[{'label':'Y','value':'Y'},{'label':'N','value':'N'}]";
            }
        }
        if (this.fcCheckedChildren === undefined) {
            this.fcCheckedChildren = 'å¼'
        }
        if (this.fcUnCheckedChildren === undefined) {
            this.fcUnCheckedChildren = 'å³'
        }
    }
     /**
     * @ignore
     */
    ngOnChanges(param) {
        super.ngOnChanges(param);
    }
    _afterParentInit() {
         /** if (this.fcOption !== undefined) {*/
         /**     let options = this.fcOption.split(',');*/
         /**     if (options.length !== 2) {*/
         /**         new Error("fcOption error,'[{'label':true,'value':true},*/
         /**     }*/
         /**     this._options = JSON.parse(this.fcOption);*/
         /** }*/
        if (this.fcShowText === 'Y') {
            this._showText = true;
        } else {
            this._showText = false;
        }
        if (this.fcShowIcon === 'Y') {
            this._showIcon = true;
        } else {
            this._showIcon = false;
        }
    }
    get value(): any {
        if (this.fcCheckValue instanceof Boolean) {
            return this._innerValue;
        } else {
            let rtnValue: any = '';
            this._options.forEach(obj => {
                if (this._innerValue === (obj.value === this.fcCheckValue)) {
                    rtnValue = obj.value;
                }
            });
            return rtnValue;
        }
    }

}


